import {createSelector} from 'reselect';
import {IBannerData} from './types';

export const smartEngageStateSelector = state => state.smartEngage;

export const smartEngageSelector = createSelector(smartEngageStateSelector, item => {
  const retVal = {
    isLoading: item.isLoading,
    dataList: [],
    dataObject:{}
  };

  if (item && item.data && item.data.slots) {
    const {slots} = item.data;

    // const {dwebHotels_banner_srp = []} = slots;
    const {mp_hotel_srp2 = []} = slots;
    const {mp_hotel_home2 = []} = slots;
    const {mp_hotel_srp3 = []} = slots;


    const listOfHomeImages = mp_hotel_home2.map((slotItem: IBannerData) => ({
      image: slotItem?.img_url || '',
      ctaUrl: slotItem?.cta_url || '',
      filter: slotItem?.filter,
    }));
    const listOfImages = mp_hotel_srp2.map((slotItem: IBannerData) => ({
      image: slotItem?.img_url || '',
      ctaUrl: slotItem?.cta_url || '',
      filter: slotItem?.filter,
    }));
    const additionalBannerImages = mp_hotel_srp3.map((slotItem: IBannerData) => ({
        image: slotItem?.img_url || '',
        ctaUrl: slotItem?.cta_url || '',
        filter: slotItem?.filter,
      }));

    retVal.dataList = [...listOfHomeImages, ...listOfImages, ...additionalBannerImages];
    retVal.dataObject = {
        listOfHomeImages:listOfHomeImages,
        listOfImages:listOfImages,
        additionalBannerImages:additionalBannerImages
    }

  }

  return retVal;
});

export const safetyHeaderDataSelectorFn = createSelector(smartEngageStateSelector, item => {
  let headerData = null;
  if (item && item.data && item.data.slots) {
    const {slots} = item.data;

    const {
      mp_hotel_home1 = [],
      mp_hotel_srp1 = [],
      mp_hotel_srp2 = [],
    } = slots;

    const allData = [...mp_hotel_home1, ...mp_hotel_srp1, ...mp_hotel_srp2];
    if (allData.length) headerData = allData[0];
  }
  return {headerData, isLoading: item.isLoading};
});

export const homeBannerDataSelector = createSelector(smartEngageStateSelector, item => {
  let listOfImages = [];
  if (item && item.data && item.data.slots) {
    const {slots} = item.data;

    const {mp_hotel_home2 = []} = slots;

    listOfImages = mp_hotel_home2.map((slotItem: IBannerData) => ({
      image: slotItem?.img_url || '',
      ctaUrl: slotItem?.cta_url || '',
      filter: slotItem?.filter,
    }));
  }

  return listOfImages;
});
